export class IngestionPipelineErrorClass {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "component",
            "baseName": "component",
            "type": "string",
            "format": ""
        },
        {
            "name": "target",
            "baseName": "target",
            "type": "string",
            "format": ""
        },
        {
            "name": "level",
            "baseName": "level",
            "type": "string",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": ""
        },
        {
            "name": "firstSeen",
            "baseName": "firstSeen",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastSeen",
            "baseName": "lastSeen",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "sampleError",
            "baseName": "sampleError",
            "type": "string",
            "format": ""
        },
        {
            "name": "sampleFields",
            "baseName": "sampleFields",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineErrorClass.attributeTypeMap;
    }
    constructor() {
    }
}
